import { render } from "./table1.vue?vue&type=template&id=722ac4dd"
const script = {}

import "./table1.vue?vue&type=style&index=0&id=722ac4dd&lang=css"

import exportComponent from "X:\\Proyecto\\riego-site\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__